module.exports = __webpack_public_path__ + "media/jackpot2.3e3ec07e.webm";